import ActionButton from 'components/action-button';
import { t } from 'state/intl/translations';

export const MissingPickerSelectionCta = () => {
  return (
    <ActionButton testID="product-home-action-button" disabled flex={1}>
      {t('pleaseSelect')}
    </ActionButton>
  );
};
